module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1200-324cbef2c404e51027f7763083e17d51.jpg";